import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const MonthlyTargetList = lazy(() => import('../Pages/MonthlyTargetList'));
const MonthlyTargetView = lazy(() => import('../Pages/MonthlyTargetView'));
const AddMonthlyTarget = lazy(() => import('../Pages/AddMonthlyTarget'));
const EditMonthlyTarget = lazy(() => import('../Pages/EditMonthlyTarget'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

function MonthlyTargetRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/business/monthly-targets"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <MonthlyTargetList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/business/monthly-targets/list"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <MonthlyTargetList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/business/monthly-targets/view/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <MonthlyTargetView history={history} />
                        </Suspense>
                    </Auth>
                )}
            />

            <Route
                exact
                path="/:lng/business/monthly-targets/add"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AddMonthlyTarget history={history} />
                        </Suspense>
                    </Auth>
                )}
            />

            <Route
                exact
                path="/:lng/business/monthly-targets/edit/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <EditMonthlyTarget history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    );
};

export default MonthlyTargetRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
